import _ from 'lodash';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import {
  deleteGlExportDownload2,
  getGeneralLedgerData2,
  getGlExportLastUpdated2,
  requestGeneralLedgerExport2,
  requestGlExportDownload2,
  requestReceivablesExport,
} from '../../../api/ledgers';
import useNavActive from '../../../components/Navbar/useNavActive';
import GeneralLedgerReportScreen2 from '../Screens/GeneralLedgerReportScreen2';
import ComputingPreloader from './ComputingPreloader';
import RowLimitExportModal from './RowLimitExportModal';

const defaultExportLoaderMessage = 'Exporting general ledger...';

const clampProgress = (progress) => {
  const numericProgress = Number(progress);
  if (Number.isNaN(numericProgress)) return 0;
  return Math.min(Math.max(numericProgress, 0), 100);
};

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// The backend returns this message when an export exceeds Excel's row maximum.
// Match on the stable "row limit exceeded" phrase (backend owns exact wording).
const isRowLimitError = (msg) => /row limit exceeded/i.test(msg ?? '');

const parseExportResponse = (responseData, fallbackMessage) => {
  const response = responseData?.data?.response ?? responseData?.data ?? {};
  const { code, result } = response;

  if (code && code !== '00000') {
    throw new Error(
      typeof result === 'string' ? result : result?.message ?? 'Export failed.',
    );
  }

  const progress = clampProgress(result?.progress);

  return {
    progress,
    message: result?.message ?? fallbackMessage,
    downloadUrl: progress >= 100 ? result?.result ?? null : null,
  };
};

const currentDate = moment().format('YYYY-MM-DD');

const formDefault = {
  date_from: currentDate,
  date_to: currentDate,
  page: 0,
  page_size: 50,
  order_by: 'account_code',
  direction: 'asc',
};

const General2 = () => {
  //declaration
  const history = useHistory();
  const [formData, setFormData] = useState(formDefault);
  const [generalLedgerData, setGeneralLedgerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRow, setTotalRow] = useState(0);
  const [reloadTable, setReloadTable] = useState(1);
  const [columnRunning, setColumnRunning] = useState(true);
  const [pageArray, setPageArray] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(50);
  const [pages, setPages] = useState([]);
  const [begBal, setBegBal] = useState(0);
  const [tableParams, setTableParams] = useState({});
  const [exportState, setExportState] = useState({
    loading: false,
    message: defaultExportLoaderMessage,
    progress: 0,
  });
  const [isExporting, setIsExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState(0);
  const [rowLimitError, setRowLimitError] = useState(null);
  const [glLastUpdated, setGlLastUpdated] = useState(null);

  useNavActive([
    'finance_and_accounting',
    'fna_financial_reports',
    'general_ledger_2',
  ]);

  //functions
  //functions
  useEffect(() => {
    loadLedgerData(formData);
    getGlExportLastUpdated2()
      .then((res) => {
        const { code, result } = res.data.response;
        if (code === '00000') setGlLastUpdated(result.last_updated);
      })
      .catch(() => {});
  }, []);

  const loadLedgerData = async (form) => {
    if (form.account_code) {
      setColumnRunning(false);
    } else {
      setColumnRunning(true);
    }

    setReloadTable(Math.floor(Math.random() * 101));
    setLoading(true);
    setGeneralLedgerData([]);
    let dateFrom = new Date(form.date_from);
    let dateTo = new Date(form.date_to);
    let allow = 0;
    if (dateFrom.getTime() === dateTo.getTime()) {
      allow = 1;
    } else if (dateFrom.getTime() < dateTo.getTime()) {
      allow = 1;
    }

    if (allow === 1) {
      try {
        let res = await getGeneralLedgerData2(form);
        console.log('GL2 raw response:', res?.data);
        const payload = res?.data?.response ?? res?.data ?? {};
        const { code, result, total_rows } = payload;

        if (code !== '00000') {
          toast.error(result);
          return;
        }

        let tmp = [];
        _.each(
          result,
          (row) => {
            tmp.push({
              id: row.id,
              journal_no: row.journal_entry,
              transaction_date: row.transaction_date,
              account_code: row.account_code,
              account_name: row.account_name,
              debit: row.debit,
              credit: row.credit,
              running_balance: row.running_balance,
              module: row.module,
              reference: row.reference,
              payee: row.payee,
              md: row.md,
              particulars: row.particulars,
              remarks: row.remarks,
              details: row.details,
              program: row.program,
              cost_center: row.cost_center,
              bank_date: row.bank_date,
              accounting_code: row.accounting_code,
              source_ref_no: row.source_ref_no,
            });
          },
          (row) => console.log('row', row),
        );

        setGeneralLedgerData(result);

        setTotalRow(total_rows);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error('Error occured. Please try again later');
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
      toast.warning('Please provide valid date!');
    }
  };

  const handleSelectedTab = (key) => {
    history.push('/finance-and-accounting/general-ledger-2');
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const getDate = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const searchLedger = (temp) => {
    toast.loading('Getting Transaction, Please wait...', {
      position: toast.POSITION.TOP_RIGHT,
    });
    if (formData.date_to === '') {
      getGeneralLedgerData2(temp)
        .then((res) => {
          if (res.data.response.code === '00000') {
            if (res.data.response.result.length === 0) {
              toast.warning('No Data Available');
            }
            toast.dismiss();
            setGeneralLedgerData(res.data.response.result);
          } else {
            Swal.fire({
              title: 'Error',
              text: res,
              icon: 'error',
            });
          }
        })
        .catch((err) => {});
    } else {
      getGeneralLedgerData2(formData)
        .then((res) => {
          if (res.data.response.code === '00000') {
            if (res.data.response.result.length === 0) {
              toast.warning('No Data Available');
            }
            toast.dismiss();
            setGeneralLedgerData(res.data.response.result);
          } else {
            Swal.fire({
              title: 'Error',
              text: res,
              icon: 'error',
            });
          }
        })
        .catch((err) => {});
    }
  };

  const handleSearch = () => loadLedgerData(formData);

  const handleDataTableChange = (params) => {
    let temp = {
      ...formData,
      ...params,
    };
    loadLedgerData(temp);
  };

  const handleTableChange = (params) => {
    const newParams = { ...formData, ...params };

    setTableParams(newParams);
    loadLedgerData(newParams);
  };

  const debouncedLoadLedgerData = useMemo(
    () => _.debounce((params) => loadLedgerData(params), 500),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useEffect(() => {
    return () => debouncedLoadLedgerData.cancel();
  }, [debouncedLoadLedgerData]);

  const handleFilterModelChange = (filterModel) => {
    const newParams = { ...formData, filter: filterModel };
    setTableParams(newParams);
    debouncedLoadLedgerData(newParams);
  };

  const OnHandleExport = () => {
    let dateFrom = new Date(formData.date_from);
    let dateTo = new Date(formData.date_to);
    let allow = 0;
    if (dateFrom.getTime() === dateTo.getTime()) {
      allow = 1;
    } else if (dateFrom.getTime() < dateTo.getTime()) {
      allow = 1;
    }
    if (allow === 0) {
      Swal.fire({
        title: 'Warning',
        text: 'Please select correct dates!',
        icon: 'warning',
      });
    } else {
      let tmp = {
        id: formData.account_code,
        date_from: formData.date_from,
        date_to: formData.date_to,
        tab: 'receivables',
      };
      toast.loading('Exporting data in progress, Please wait...', {
        position: toast.POSITION.TOP_RIGHT,
      });
      requestReceivablesExport(tmp)
        .then((res) => {
          if (res.data.response.code === '00000') {
            window.location.href = res.data.response.result;
            toast.dismiss();
          } else {
            Swal.fire({
              title: 'Error',
              text: res,
              icon: 'error',
            });
          }
        })
        .catch((err) => {});
    }
  };

  const pollExport = async () => {
    const payload = {
      account_code: formData.account_code || null,
      date_from: formData.date_from,
      date_to: formData.date_to,
    };

    const res = await requestGeneralLedgerExport2(payload);
    const { progress, message, downloadUrl } = parseExportResponse(
      res,
      defaultExportLoaderMessage,
    );

    // The API surfaces the row-limit condition through the status message
    // (not an error code), so detect it here and stop polling.
    if (isRowLimitError(message)) {
      throw new Error(message);
    }

    setExportState({
      loading: true,
      message: progress >= 100 ? 'Downloading your export...' : message,
      progress,
    });

    if (progress >= 100) {
      return downloadUrl;
    }

    await delay(1000);
    return pollExport();
  };

  const handleGlExportDownload = async () => {
    setExportState({
      loading: true,
      message: defaultExportLoaderMessage,
      progress: 0,
    });

    try {
      const downloadUrl = await pollExport();

      if (!downloadUrl) {
        throw new Error('Export failed.');
      }

      window.location.href = downloadUrl;
    } catch (error) {
      const msg = error?.message ?? 'Export failed. Please try again.';
      if (isRowLimitError(msg)) {
        setRowLimitError(msg);
      } else {
        Swal.fire({ title: 'Error', text: msg, icon: 'error' });
      }
    } finally {
      setExportState({
        loading: false,
        message: defaultExportLoaderMessage,
        progress: 0,
      });
    }
  };

  const handleLongExport = () => {
    setIsExporting(true);
    setExportProgress(0);

    const processExport = (sessionId, cursor) => {
      const payload = {
        from_date: formData.date_from,
        to_date: formData.date_to,
        account_code: formData.account_code || null,
        session_id: sessionId,
        cursor: cursor,
      };

      requestGlExportDownload2(payload)
        .then((res) => {
          const { code, result } = res.data.response;

          if (code !== '00000') {
            setIsExporting(false);
            Swal.fire({ title: 'Error', text: result, icon: 'error' });
            return;
          }

          if (result.link) {
            window.open(result.link, '_blank');
            deleteGlExportDownload2({ session_id: sessionId })
              .then((deleteRes) => {
                if (deleteRes.data.response.code === '00000') {
                  setIsExporting(false);
                }
              })
              .catch(() => {
                setIsExporting(false);
              });
          } else {
            setExportProgress(Math.round(result.percentage));
            processExport(result.session_id, result.next_cursor);
          }
        })
        .catch(() => {
          setIsExporting(false);
          Swal.fire({
            title: 'Error',
            text: 'Export failed. Please try again.',
            icon: 'error',
          });
        });
    };

    processExport('', null);
  };

  return (
    <>
      <GeneralLedgerReportScreen2
        //throw parameter or props.
        formData={formData}
        dateChange={getDate}
        onSearch={searchLedger}
        handleSearch={handleSearch}
        generalLedgerData={generalLedgerData}
        selectedTab={'general_ledger'}
        handleSelectedTab={handleSelectedTab}
        handleChange={handleChange}
        loading={loading}
        totalRow={totalRow}
        handleDataTableChange={handleDataTableChange}
        handleFilterModelChange={handleFilterModelChange}
        handleTableChange={handleTableChange}
        reloadTable={reloadTable}
        handleExport={OnHandleExport}
        columnRunning={columnRunning}
        onHandlegeneralLedgerExport={handleGlExportDownload}
        onHandleGlExportDownload={handleLongExport}
        isExporting={isExporting}
        exportProgress={exportProgress}
        glLastUpdated={glLastUpdated}
        breadcrumb={{
          parent: 'Finance and Accounting',
          section: 'Financial Report',
          current: 'General Ledger',
        }}
      />
      {exportState.loading && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: 12,
              padding: '18px 40px',
              minWidth: 420,
              boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
            }}
          >
            <ComputingPreloader
              message={exportState.message}
              progress={exportState.progress}
            />
          </div>
        </div>
      )}
      {rowLimitError && (
        <RowLimitExportModal
          message={rowLimitError}
          onClose={() => setRowLimitError(null)}
        />
      )}
    </>
  );
};

export default General2;
